module.exports = __webpack_public_path__ + "img/logo_brasao.e329fcda.png";